var countdownDate = new Date(Date.UTC(2025, 11, 2, 8, 0, 0)); 










// Update the countdown every 1 second
var countdowndrop = setInterval(function() {

  // Get the current date and time
  var now = new Date().getTime();

  // Calculate the remaining time in milliseconds
  var distance = countdownDate - now;

  // Calculate the remaining time in days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000); 

  // Display the countdown in the HTML element with the ID "countdown"
  if (days > 0) {
    document.getElementById("countdowndrop").innerHTML = "IN " + days + "D " + hours + "H "
    + minutes + "M "; //+ seconds + "S"
  } else {
    document.getElementById("countdowndrop").innerHTML = "IN " + hours + "H "
    + minutes + "M " + seconds + "S";
  }

  // If the countdown is over, stop the countdown and display "MESSAGE"
  if (distance < 0) {
    clearInterval(countdowndrop);
    document.getElementById("countdowndrop").innerHTML = "DROP NOW LIVE";
  }
}, 1000);
 